import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericApiResponseError } from '@core/generic-api/data-access';
import { ToastService } from '@shared/components/toast';
import { ParticipantApiService } from '../../api/participant-api.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'portal-signing-verify-code',
  templateUrl: './verify-code-modal.component.html',
  styleUrls: ['./verify-code-modal.component.scss'],
})
export class VerifyCodeModalComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  reason: any;
  @ViewChild('otpRef') otpRef!: ElementRef;
  canSubmit = false;
  countSendingOTP = 0;
  reachedMax = false;
  notValid = false;

  constructor(
    private participantApiService: ParticipantApiService,
    private toastService: ToastService,
    private dialogRef: MatDialogRef<VerifyCodeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { accessToken: string; phone: string },
  ) {}

  ngOnInit(): void {
    this.sendOTP(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  sendOTP(showNotification = true) {
    this.countSendingOTP++;
    if (this.countSendingOTP < 5 && !this.reachedMax) {
      this.participantApiService
        .sendVerification(this.data.accessToken)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            if (showNotification) {
              this.toastService.notify({
                type: 'success',
                messages: 'The OTP Code has been sent to your phone number',
              });
            }
          },
          error: (error: GenericApiResponseError) => {
            if (error.statusCode === 429) {
              this.reachedMax = true;
            }
          },
        });
    }
  }

  submit(): void {
    const code = this.getCode();
    this.participantApiService
      .verify(
        {
          phone: this.data.phone,
          code,
        },
        this.data.accessToken,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: res => {
          if (res) {
            this.dialogRef.close({
              isSubmit: true,
            });
          }
        },
        error: error => {
          if (error.statusCode === 400) {
            this.notValid = true;
          }
        },
      });
  }

  getCode() {
    return Array.from(this.otpRef.nativeElement.children)
      .map((el: any) => el['value'])
      .join('');
  }

  close(): void {
    this.dialogRef.close();
  }

  inputInsideOtpInput(event: any) {
    if (event.target.value.length > 1) {
      event.target.value = event.target.value[0];
    }

    if (event.data == null || event.data === '') {
      if (event.target.previousElementSibling) {
        event.target.previousElementSibling.focus();
      }
    } else {
      if (event.target.nextElementSibling) {
        event.target.nextElementSibling.focus();
      }
    }
    this.canSubmit = this.getCode().length === 6;
  }
}
